import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteNoGravadoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='NO GRAVADO' htmlFor='input-importeNoGravado' md={12} />
      <Col md={12}>
        <Form.InputNumber
          id='input-importeNoGravado'
          name='input-importeNoGravado'
          value={iValue}
          disabled
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteNoGravadoFormGroup)
